module.exports = __webpack_public_path__ + "img/215.78f14752.png";